import { defineMessages } from 'react-intl';

const messages = defineMessages({
  PlannedRegistrationOverview: 'Planned registration overview',
  FinancialStatementScheme: 'FinancialStatementScheme',
  AssignedToMe: 'Assigned to me',
  Unassigned: 'Unassigned',
  SelectAll: 'Select all',
  SelectYourFilters: 'Select your filters',
  Filters: 'Filters',
  ResetFilters: 'Reset filters',
  WithPriceListItem: 'With price list item',
  WithoutPriceListItem: 'Without price list item',
  WithPlannedRegistrations: 'With planned registrations',
  WithoutPlannedRegistrations: 'Without planned registrations',
  Relation: 'Relation',
  UniqueIdentifier: 'Unique Identifier',
  RelationCode: 'Relation code',
  Assignment: 'Assignment',
  Schedule: 'Schedule',
  NextPlanningDate: 'Next planning date',
  PlanningStartStop: 'Planning start - stop',
  Resource: 'Resource',
  Quantity: 'Quantity',
  UnitPrice: 'Unit price',
  Amount: 'Amount',
  GlobalActions: 'Global actions',
  ExportToExcel: 'Export to Excel',
  AddPlannedRegistrations: 'Add planned registrations',
  RemovePlannedRegistrations: 'Remove planned registrations',
  RemovePlannedRegistrationsConfirmationMsg:
    'Are you sure you want to remove all selected planned registrations?',
  GlobalActionStarted: 'Global action was started, click here to see its progress',
  DayAndMonth: 'Day and month',
  DayOfTheMonth: 'Day of the month',
  Day: 'Day',
  ResourceType: 'Resource type',
  StartDate: 'Start date',
  EndDate: 'End date',
  CountSelected: 'Selected {count} / {total}',
  Other: 'Other',
  SendEmail: 'Send email',
  EndFiscalYear: 'End fiscal year',
  EmptyFiscalYear: 'Empty fiscal year',
  CreateSingleRegistration: 'Create single registration',
  ColumnConfig: 'Configure columns',
  SelectOverviewColumns: 'Select overview columns',
  SelectColumns: 'Select columns',
  ExportToExcelStarted: 'Export to Excel started',
  User: 'User',
  SystemUser: 'System user',
  ChangeUser: 'Change user',
  InForfait: 'In forfait',
  DetermineWhenCreatingRegistration: 'Use general settings on moment of creation',
  ExcludedFromFixedAmountAdvance: 'Excluded from fixed amount/advance',
  IncludedInFixedAmountAdvance: 'Included in fixed amount/advance',
});

export default messages;
